/* src/app/forms/produtos/mercadolivre/catalogo/catalogo.component.scss */
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  overflow: hidden;
}
.card-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border: 1px solid var(--tem-border, #e5e8ec);
  border-radius: var(--tem-radius, 10px);
  background: var(--tem-surface, #fff);
}
.main-title {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-text {
  font-size: var(--tem-fs-lg, 16px);
  font-weight: 500;
}
.spacer {
  flex: 1;
}
.form-field {
  min-width: 220px;
}
.button-field {
  margin-left: 4px;
}
.field-action {
  cursor: pointer;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.field-action:hover {
  color: var(--tem-deep, #1890ff);
}
.card-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 55vh;
  padding-top: 20px;
}
.variation-inner-grid {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-right: 10px;
  display: flex;
  flex-direction: row;
}
.variation-inner-grid-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 0 0 auto;
}
.button-variation {
  width: 100%;
  text-align: center;
  min-height: 40px;
  max-height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.button-variation button {
  font-size: 90%;
  width: 150px;
  height: 30px;
  line-height: 30px;
}
.variation-grid-simple {
  width: 300px;
  height: 100%;
  position: relative;
}
.lines {
  display: grid;
  width: 100%;
  align-content: center;
}
.columns-grid {
  border-bottom: 1px solid var(--tem-border, #e9ecef);
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.data-left {
  width: 100%;
}
.bold {
  font-weight: 500;
}
.pointerMenu {
  cursor: pointer;
}
/*# sourceMappingURL=catalogo.component.css.map */
